import { useShallow } from 'zustand/shallow';

import { Permission } from './auth.types';
import { useAuthStore } from './authStore';

// ===== Getters =====

export const useIdToken = () => useAuthStore(state => state.idToken); // if used "outside React" - useAuthStore.getState().idToken
export const useAuthUsername = () => useAuthStore(state => state.authUsername);
export const useJwtPayload = () => useAuthStore(state => state.jwtPayload);
export const useCurrentUser = () => useAuthStore(state => state.currentUser);
export const useHasPermission = (permission: Permission) =>
	useAuthStore(state => {
		if (permission === Permission.DcrEnabled) {
			return !!state.currentUser?.dcrEnabled;
		}

		return state.jwtPayload
			? state.jwtPayload['custom:permissions'].split(',').includes(permission)
			: false;
	});

export const useSetCurrentUser = () =>
	useAuthStore(useShallow(({ setCurrentUser }) => setCurrentUser));
